import React, { useEffect, useState } from "react"
import { Input, Table, Row, Col, Label } from "reactstrap"
import SelectBox from "components/Common/SelectBox"

{
  /* ラジオボタン = Radio, プルダウン : dropdown/elect, チェックボックス : checkbox, TEXT  */
}

export default function Correction(props) {
  const { config } = props

  const { pantsCorrections, setPantsCorrections } = config

  const onDropdownSelect = (e, v, i) => {
    const answer = { sequence: e.value, answer: e.label }
    const stateCorrections = [...pantsCorrections]
    const correction = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }

    stateCorrections[i] = {
      label: correction.answers[0].answer,
      value: correction.answers[0].sequence,
    }
    config.handlePantsInput(correction, "corrections", i)
    setPantsCorrections(stateCorrections)
  }

  const onRadioSelect = (e, v, i, l) => {
    const answer = { sequence: parseInt(e.target.value), answer: l }
    const correction = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }
    config.handlePantsInput(correction, "corrections", i)
  }

  const onCheckboxChecked = (e, v, i) => {
    const answers = []
    const grandParent = e.target.parentNode.parentNode
    const checkBoxes = grandParent.querySelectorAll(`[name="${e.target.name}"]`)

    checkBoxes.forEach(checkBox => {
      if (checkBox.checked) {
        const { answer } = checkBox.dataset
        answers.push({
          sequence: parseInt(checkBox.value),
          answer: answer,
        })
      }
    })
    const correction = {
      formId: v.formId,
      sequence: v.sequence,
      answers: answers,
    }
    config.handlePantsInput(correction, "corrections", i)
  }

  const onTextInputChanged = (e, v, i) => {
    const answer = {
      sequence: parseInt(e.target.dataset.sequence),
      answer: e.target.value,
    }
    const correction = {
      formId: v.formId,
      sequence: v.sequence,
      answers: [answer],
    }
    config.handlePantsInput(correction, "corrections", i)
  }

  return (
    <Table bordered>
      <tbody>
        {config.orderSheets.pants.corrections.map((v, i) => {
          if (!v.item) return null
          return (
            <tr key={i}>
              <td>
                <p className="mb-0">{v?.item || "-"}</p>
              </td>
              <td>
                <Row className="gy-3">
                  {v.format === "ラジオボタン" ? ( // radio
                    <div className="d-flex justify-content-start gap-4">
                      {v.labels.map(l => {
                        const { corrections } = config.payload.pants
                        let isChecked = false
                        if (corrections[i] !== undefined) {
                          if (corrections[i].answers[0].answer === l.label) {
                            isChecked = true
                          }
                        }
                        return (
                          <div className="d-flex" key={l.sequence}>
                            <Input
                              name={`${v.formId}${i}`}
                              id={`corr${v.formId}${i}${l.sequence}`}
                              className="me-2"
                              type="radio"
                              onChange={e => onRadioSelect(e, v, i, l.label)}
                              value={l.sequence}
                              // defaultChecked={isChecked}
                            />
                            <Label htmlFor={`corr${v.formId}${i}${l.sequence}`}>
                              {l.label}
                            </Label>
                          </div>
                        )
                      })}
                    </div>
                  ) : v.format === "プルダウン" ? ( // select
                    <div style={{ width: "100%" }}>
                      <SelectBox
                        options={v.labels.map(l => ({
                          label: l.label,
                          value: l.sequence,
                        }))}
                        onChange={e => onDropdownSelect(e, v, i)}
                        value={pantsCorrections[i]}
                      />
                    </div>
                  ) : v.format === "チェックボックス" ? ( // checkbox
                    <div className="d-flex justify-content-between">
                      {v.labels.map(l => {
                        let isChecked = false
                        const correction = config.payload.pants.corrections[i]
                        if (correction.answers.length) {
                          if (
                            correction.answers?.findIndex(
                              item => item.answer === l.label
                            ) !== -1
                          ) {
                            isChecked = true
                          }
                        }
                        return (
                          <div className="d-flex" key={l.sequence}>
                            <Input
                              name={`${v.formId}${i}`}
                              id={`cor${v.formId}${i}${l.sequence}`}
                              className="me-2"
                              type="checkbox"
                              value={l.sequence}
                              onChange={e => onCheckboxChecked(e, v, i)}
                              data-answer={l.label}
                              // defaultChecked={isChecked}
                              defaultChecked={false}
                            />
                            <Label htmlFor={`cor${v.formId}${i}${l.sequence}`}>
                              {l.label}
                            </Label>
                          </div>
                        )
                      })}
                    </div>
                  ) : (
                    // text input
                    <div style={{ width: "100%" }}>
                      <Input
                        className="me-2"
                        type="text"
                        onChange={e => onTextInputChanged(e, v, i)}
                        data-sequence={1}
                        defaultValue={
                          config?.payload?.pants?.corrections[i]?.answers[0]
                            ?.answer
                        }
                      />
                    </div>
                  )}
                </Row>
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
